import type { AppDispatch } from '@/app/store/store';
import type { PlpRepository, FetchListingOptions } from '../../domain/interfaces/PlpRepository';
import { ProductListing } from '../../domain/models/ProductListing';
import { fetchPlpListingPage } from './plpListingFetch';
import type { SeoRepository } from '@/shared/features/seo/domain/interfaces/SeoRepository';

export { plpApi, plpApiRedux } from './plpListingApi';
export type { PlpListingRequestArgs } from './plpListingApi';
export { buildPlpFullUrl } from '../utils/plpListingRequest';
export { mergePlpSplitResponsesToPlain } from './plpListingFetch';

/**
 * Repository Adapter
 * Implements PlpRepository using query client
 */
export class plpAdapter implements PlpRepository {
  constructor(
    private readonly dispatch: AppDispatch,
    private readonly seoRepo: SeoRepository
  ) {}

  async fetchListing(
    params: Parameters<PlpRepository['fetchListing']>[0],
    options?: FetchListingOptions
  ): Promise<ProductListing> {
    try {
      return await fetchPlpListingPage(this.dispatch, params, this.seoRepo, options);
    } catch (error) {
      if (error instanceof DOMException && error.name === 'AbortError') {
        throw error;
      }
      console.error('Error fetching PLP data:', error);
      return new ProductListing({
        header: '',
        totalCount: 0,
        filters: [],
        designs: [],
      });
    }
  }
}
